import { Navigate, useLocation } from "react-router-dom";

import { FirebaseAuthContainer } from "../../../common/containers/auth/firebase-auth-container.util";
import { LoaderView } from "../../../components/loader/loader.comp";
import { isAuthDomain } from "../../../common/utilities/routes/routes.util";
import { AuthDomainRedirect } from "../auth-domain-redirect.comp";

const VerifiedProtectedRoute = ({ children }: { children: JSX.Element }) => {
    // Use isAuthenticatedState (reactive) instead of isAuthenticated() (function)
    // This ensures component re-renders when auth state changes
    const { isAuthenticatedState, emailVerified, user, knowledgeBase, isTrial } =
        FirebaseAuthContainer.useContainer();
    const location = useLocation();

    return isAuthenticatedState ? (
        emailVerified &&
        !!user?.currentKnowledgeBaseId &&
        !!knowledgeBase &&
        (!isTrial ||
            (knowledgeBase?.expiringTrialPeriod != null &&
                knowledgeBase?.expiringTrialPeriod > 0)) ? (
            children
        ) : emailVerified !== true ? (
            <Navigate to="/email-confirm" state={{ from: location }} />
        ) : isTrial &&
          knowledgeBase?.expiringTrialPeriod != null &&
          knowledgeBase?.expiringTrialPeriod < 1 ? (
            <Navigate to="/trial-upgrade" state={{ from: location }} />
        ) : !!user && !user.currentKnowledgeBaseId ? (
            <Navigate to="/knowledge-base-unavailable" state={{ from: location }} />
        ) : (
            <LoaderView show={true} />
        )
    ) : isAuthDomain() ? (
        <Navigate to="/login" state={{ from: location }} />
    ) : (
        <AuthDomainRedirect targetPath="/login" currentLocation={location} />
    );
};

export default VerifiedProtectedRoute;
